module.exports = __webpack_public_path__ + "img/fwdw_04.65fdc986.jpg";